import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import { PageHeaderWrap } from './page-header.style'
import PageHeaderCustomBg from '../../../components/pageheadercustombg';


const PageHeader = ({ pageContext, location, crumbLabel, sectionStyle, titleStyle, descStyle }) => {
    const PageHeaderData = useStaticQuery(graphql`query AboutPageHeaderQuery {
  aboutUsJson(jsonId: {eq: "about-page-header-data"}) {
    title
    desc
    bg_image {
        childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH, quality: 75, placeholder: BLURRED)
        }
    }
  }
}
`);
    const aboutUsJson = PageHeaderData.aboutUsJson;
    if (!aboutUsJson) {
        console.warn("AboutUs PageHeader: aboutUsJson is null");
        return null;
    }
    const { title, desc, bg_image } = aboutUsJson;
    const imageData = bg_image?.childImageSharp?.gatsbyImageData;
    return <PageHeaderCustomBg
        pageContext={pageContext}
        location={location}
        title="About Us"
        image={imageData}
        textColor="#4b1e79"
        crumbLabel={crumbLabel}
    />
}

PageHeader.propTypes = {
    descStyle: PropTypes.object,
    titleStyle: PropTypes.object
}

PageHeader.defaultProps = {
    titleStyle: {
        as: 'h1',
        color: "#4b1e79",
        mb: '15px'
    },
    descStyle: {
        as: "h5",
        color: "#4b1e79",
        fontweight: 400
    }
}

export default PageHeader;